import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const CompanySizesEdit = props => (
  <Edit {...props} resource="companySizes">
    <Form />
  </Edit>
);

CompanySizesEdit.propTypes = {};

export default CompanySizesEdit;
